function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as aftersaleApi from '@/api/aftersaleApi.js';
import { Debounce } from '@/utils/validate.js';
import { compensationTypeOption } from './static.js';
export default {
  data: function data() {
    return {
      loadSubmit: false,
      visible: false,
      initLoading: false,
      detailInfo: {},
      buttonClicked: false,
      compensationTypeOption: compensationTypeOption,
      compensationData: {
        compensationType: '',
        compensationAmount: 0,
        compensationRemark: ''
      },
      rules: {
        compensationType: [{
          required: true,
          message: '请选择赔付类型',
          trigger: 'change'
        }],
        compensationAmount: [{
          required: true,
          message: '请输入赔付金额',
          trigger: 'blur'
        }, {
          type: 'number',
          min: 0.01,
          message: '赔付金额必须大于0',
          trigger: 'blur'
        }],
        compensationRemark: [{
          required: false,
          message: '请输入赔付说明',
          trigger: 'blur'
        }, {
          max: 200,
          message: '赔付说明长度不能超过200个字符',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    initOpen: function initOpen(aftersaleId) {
      var _this = this;
      if (!aftersaleId) return;
      this.visible = true;
      this.initLoading = true;
      this.detailInfo = {};
      this.buttonClicked = false;

      // 重置表单数据
      this.compensationData = {
        compensationType: '',
        compensationAmount: 0,
        compensationRemark: ''
      };

      // 获取售后详情
      aftersaleApi.getSaleDetails(aftersaleId).then(function (res) {
        _this.detailInfo = _objectSpread({}, res);
        _this.initLoading = false;
      }).catch(function (err) {
        _this.$message.error('获取售后详情失败');
        _this.initLoading = false;
      });
    },
    // 按钮点击处理函数 - 立即响应UI变化
    onCompensationSubmit: function onCompensationSubmit() {
      var _this2 = this;
      // 已在处理中或按钮已被点击，阻止重复操作
      if (this.loadSubmit || this.buttonClicked) return;

      // 表单验证
      this.$refs.compensationForm.validate(function (valid) {
        if (valid) {
          // 立即更新UI状态
          _this2.buttonClicked = true;

          // 执行实际的提交操作（防抖处理）
          _this2.processCompensationSubmission();
        } else {
          return false;
        }
      });
    },
    // 实际的提交处理 - 应用防抖
    processCompensationSubmission: Debounce(function () {
      var _this3 = this;
      // 如果已经在提交中，则不重复执行
      if (this.loadSubmit) return;
      this.loadSubmit = true;

      // 构建提交数据
      var submitData = {
        id: this.detailInfo.id,
        compensationRequest: {
          compensationType: this.compensationData.compensationType,
          compensationAmount: Number(parseFloat(this.compensationData.compensationAmount).toFixed(2)),
          compensationRemark: this.compensationData.compensationRemark || ''
        }
      };

      // 调用API提交赔付信息
      aftersaleApi.submitCompensation(submitData).then(function (res) {
        _this3.loadSubmit = false;
        _this3.$message.success('赔付操作成功！');
        _this3.visible = false;
        _this3.$emit('doRefresh');
      }).catch(function (err) {
        _this3.loadSubmit = false;
        _this3.buttonClicked = false; // 失败时重置按钮状态，允许重新提交
        _this3.$message.error('赔付操作失败：' + (err.message || '未知错误'));
      });
    }, 800),
    // 设置800ms的防抖时间
    // 关闭弹窗时重置状态
    handleClose: function handleClose() {
      if (this.loadSubmit) return; // 如果正在提交，不允许关闭
      this.buttonClicked = false;
      this.visible = false;
    }
  }
};